export default __webpack_public_path__ + "static/media/KOD0012-min.a9fffa61.webp";